/**
* WYSIWYG three col JS
* -----------------------------------------------------------------------------
*
* All the JS for the WYSIWYG three col component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {

    className: 'wysiwyg-three-col',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {

    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'wysiwyg-three-col', COMPONENT );
} )( app );
